<template>
    <div class="card">
        <div class="card-header">
            <h2 class="card-title fw-bolder">{{ $t('pages.module.eTep.question.save.questionType.speakListen.title') }}</h2>
        </div>
        <div class="card-body d-flex flex-column p-9">
            <div class="fv-row mb-7">
                <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.listen.contentArea.cols.content') }}</label>
                <el-form-item prop="data.data.content" :rules="$validation.getMessage(['required'])">
                    <CustomCkeditor :model="data.content" @updateModel="data.content = $event"></CustomCkeditor>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.listen.contentArea.cols.image') }}</label>
                <el-form-item prop="image_id">
                    <el-upload :file-list="image.fileList" :accept="$root.acceptFileSupported('image', 'image/')" class="upload-file" :on-change="handleChangeImage" :on-remove="handleChangeImage" :auto-upload="false" drag :multiple="false" :limit="1">
                        <el-icon class="el-icon--upload">
                             <span class="svg-icon">
                                 <inline-svg src="/media/icons/duotune/files/fil022.svg"/>
                             </span>
                        </el-icon>
                        <div class="el-upload__text">{{ $t('pages.module.eTep.question.save.questionType.listen.contentArea.cols.dragAreaImageContent') }}</div>
                    </el-upload>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.speakListen.cols.dragArea') }}</label>
                <el-form-item prop="track_id">
                    <el-upload :file-list="track.fileList" :accept="$root.acceptFileSupported('sound', '.')" class="upload-file" :on-change="handleChangeTrack" :on-remove="handleChangeTrack" :auto-upload="false" drag :multiple="false" :limit="1">
                        <el-icon class="el-icon--upload">
                             <span class="svg-icon">
                                 <inline-svg src="/media/icons/duotune/files/fil022.svg"/>
                             </span>
                        </el-icon>
                        <div class="el-upload__text">{{ $t('pages.module.eTep.question.save.questionType.speakListen.cols.dragAreaContent') }}</div>
                    </el-upload>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.listen.contentArea.cols.beforePlayWaitingSecond') }}</label>
                <el-form-item prop="data.data.options.before_play_waiting_second" :rules="$validation.getMessage(['required'])">
                    <el-input-number v-model="data.options.before_play_waiting_second" :min="1" :max="120"/>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.writeParagraph.cols.minWord') }}</label>
                <el-form-item prop="data.data.options.min_word" :rules="$validation.getMessage(['required'])">
                    <el-input-number v-model="data.options.min_word" :min="1"/>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.writeParagraph.cols.maxWord') }}</label>
                <el-form-item prop="data.data.options.max_word" :rules="$validation.getMessage(['required'])">
                    <el-input-number v-model="data.options.max_word" :min="1"/>
                </el-form-item>
            </div>
        </div>
    </div>
</template>

<script>
import CustomCkeditor from "@/components/custom-ckeditor/index.vue";
import md5 from 'md5'

export default {
    name: "WriteChartListen",
    props: {
        data: Object,
        track: Object,
        image: Object,
    },
    data() {
        return {
            paragraphPreview: true,
        }
    },
    components: {
        CustomCkeditor
    },
    methods: {
        handlePictureCardPreview(file) {
            this.image.dialogImageUrl = file.url
            this.image.dialogVisible = true
        },
        handleChangeImage(file, fileList) {
            this.image.fileList = fileList;
            this.image.uploadList = fileList;
        },
        handleChangeTrack(file, fileList) {
            this.track.fileList = fileList;
            this.track.uploadList = fileList;
        }
    }
};
</script>
